export default __webpack_public_path__ + "assets/salon-neuf-chaleureux-quebec.77ae8d86.webp";